module.exports = __webpack_public_path__ + "img/Adegbe.53b47eb3.jpeg";